import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/directives'
import '@/icons/components'
import '@/permission'

// 添加声明模块以修复类型错误
// @ts-ignore
import VueVideoPlayer from "vue-video-player"
import 'video.js/dist/video-js.css'

Vue.use(ElementUI)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
})

// 配置 v-viewer
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    toolbar: true,
    title: false,
    movable: true,
    zoomable: true,
    rotatable: true
  }
})
Vue.use(VueVideoPlayer)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
